import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const BlocksMenuIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 28, height = 28, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        ref={ref}
        viewBox="0 0 28 28"
        fill="none"
        {...props}
      >
        <path
          d="M4.66675 4.6666H11.6667V11.6666H4.66675V4.6666Z"
          stroke="#1F2733"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3334 4.6666H23.3334V11.6666H16.3334V4.6666Z"
          stroke="#1F2733"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66675 16.3333H11.6667V23.3333H4.66675V16.3333Z"
          stroke="#1F2733"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3336 16.3333H23.3336V23.3333H16.3336V16.3333Z"
          stroke="#1F2733"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
